import { HiOutlineTrash } from 'react-icons/hi';
import { ThreadItemAggregate } from './threadItemModel';
import { ThreadItemViewProps, ThreadItemControllerProps } from './threadItemProps';

export function buildThreadItemProps(
    item: ThreadItemAggregate,
    props: ThreadItemControllerProps
): ThreadItemViewProps {
    return {
        id: item.integration.id,
        label: item.definition.display_name,
        action: {
            kind: 'link',
            link: {
                id: `${item.integration.id}_integration_link`,
                to: `/reporting/integrations/${item.integration.id}`,
            },
        },
        hover: {
            element: {
                onMouseEnter: () => props.hover.onChange(true),
                onMouseLeave: () => props.hover.onChange(false),
            },
        },
        menu: {
            isVisible: props.disclosure.menu.isOpen || props.hover.value,
            popover: {
                ...props.disclosure.menu,
            },
            items: [
                {
                    kind: 'action',
                    label: 'Delete',
                    colorScheme: 'red',
                    Icon: HiOutlineTrash,
                    action: {
                        kind: 'button',
                        onClick: async () => {
                            await props.onDelete();
                            props.disclosure.menu.onClose();
                        },
                    },
                },
            ],
        },
    };
}
